import React from 'react';
import classNames from 'classnames';

class Button extends React.PureComponent {

  handleClick = event => !this.props.needsToLoad && this.props.onClick(event);

  render() {
    const { needsToLoad = false, title, className: classNamesForButton = {} } = this.props;
    const buttonClassNames = classNames({ loading: needsToLoad });

    return (
      <button className={buttonClassNames + ` ${classNamesForButton}`} onClick={this.handleClick}>
        <span>{title}</span>
        {this.props.icon && <i className={this.props.icon} />}
        {needsToLoad && <div className="icon-spinner" />}
        {this.props.children}
      </button>
    )
  }
};

export default Button;
